import { render, staticRenderFns } from "./Section5.vue?vue&type=template&id=4fe3c438"
import script from "./Section5.vue?vue&type=script&lang=js"
export * from "./Section5.vue?vue&type=script&lang=js"
import style0 from "./Section5.vue?vue&type=style&index=0&id=4fe3c438&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports